import { WebViewerInstance } from '@pdftron/webviewer';

export const getViewOnlyToolBar = (instance: WebViewerInstance) => {
    const { UI } = instance;

    const menuButton = new UI.Components.ToggleElementButton({
        dataElement: 'menuButton',
        img: 'ic-hamburger-menu',
        title: 'component.menuOverlay',
        toggleElement: 'MainMenuFlyout',
        // @ts-expect-error ignore
        type: 'toggleButton',
    });

    const zoomControls = new UI.Components.Zoom({});

    const defaultRibbonItems = UI.getRibbonGroup('default-ribbon-group').items as any[];
    const viewRibbonItem = defaultRibbonItems.find(
        (item) => item?.dataElement === UI.ToolbarGroup.VIEW,
    );

    const viewRibbonGroup = new UI.Components.RibbonGroup({
        items: viewRibbonItem ? [viewRibbonItem] : [],
    });

    const defaultHeader = UI.getModularHeader('default-top-header');
    defaultHeader.setItems([menuButton, zoomControls, viewRibbonGroup]);
};
